import { request } from "utils/api";
import { RequestResponse } from "utils/base_api";

export interface ChatMessage {
  message: string;
  role: "user" | "assistant";
}

export interface ChatHistory {
  history: ChatMessage[];
}

export function getHistory(questionId: number): Promise<RequestResponse> {
  return request(`/chat?question_id=${questionId}`);
}

export function sendMessage(
  questionId: number,
  message: string
): Promise<RequestResponse> {
  return request("/chat", {
    method: "POST",
    body: { question_id: questionId, message }
  });
}

export function resetChat(questionId: number): Promise<RequestResponse> {
  return request("/chat/reset", {
    method: "POST",
    body: { question_id: questionId }
  });
}
